import dayjs from 'dayjs'
import { compose, withProps, withPropsOnChange, lifecycle } from 'recompose'
import {
  withDatepickerState,
  withDatepickerStateHandlers,
  withDatepickerFocusHandlers,
  withDatepickerProps,
  withDatepickerEventHandlers
} from 'components/common/Datepicker'
import { processMonthData } from 'components/common/Datepicker/helpers'
import { isDisabledDate, canProceedBack, canProceedForward } from './helpers'
import Datepicker from './Datepicker'

const withDatepickerCustomization = withProps(({ dates }) => ({
  titleFormat: 'MMMM',
  processMonthData: (month, date) => processMonthData(month, date, (date) => isDisabledDate(dates, date)),
  dataAtAttrs: {
    wrapperAttrs: {
      'data-at-quickappointment-calendar': true
    },
    cellAttrs: ({ active }) => ({
      'data-at-quickappointment-calendar-day': !active ? true : null,
      'data-at-quickappointment-calendar-day-enabled': active ? true : null
    })
  }
}))

const withDatepickerNavigationState = withPropsOnChange(
  ({ dates, currentMonth }, { dates: previousDates, currentMonth: previousMonth }) =>
    dates !== previousDates || !currentMonth.isSame(previousMonth, 'month'),
  ({ dates, currentMonth }) => ({
    proceedBack: canProceedBack(dates, currentMonth),
    proceedForward: canProceedForward(dates, currentMonth)
  })
)

const withDatepickerLifecycle = lifecycle({
  componentDidUpdate({
    focusedRef: prevFocusedRef,
    firstDateSelected: prevFirstDateSelected
  }) {
    const {
      focusedRef,
      currentDate,
      currentMonth,
      firstDateSelected,
      setFirstDateSelected,
      handleMoveMonthBack,
      handleMoveMonthForward
    } = this.props
    if (prevFirstDateSelected !== firstDateSelected && firstDateSelected) {
      const isSameMonth = dayjs(currentDate).isSame(currentMonth, 'month')

      if (!isSameMonth) {
        const oldMonth = currentMonth.month()
        const newMonth = dayjs(currentDate).month()

        setFirstDateSelected(false)
        newMonth < oldMonth ? handleMoveMonthBack() : handleMoveMonthForward()
      } else {
        setFirstDateSelected(false)
      }
    }

    if (focusedRef && prevFocusedRef) {
      const prevDate = dayjs(new Date(prevFocusedRef.dataset.date).toISOString())
      const date = dayjs(new Date(focusedRef.dataset.date).toISOString())

      const isSameDate = prevDate.isSame(date)
      const isDifferentMonth = !prevDate.isSame(date, 'month')
      const wasSelected = prevFocusedRef.getAttribute('aria-selected') === 'false' &&
        focusedRef.getAttribute('aria-selected') === 'true'

      if ((isSameDate && wasSelected) || isDifferentMonth || !isSameDate) {
        focusedRef.focus()
      }
    }
  }
})

export default compose(
  withDatepickerCustomization,
  withDatepickerState,
  withDatepickerNavigationState,
  withDatepickerStateHandlers,
  withDatepickerFocusHandlers,
  withDatepickerLifecycle,
  withDatepickerProps,
  withDatepickerEventHandlers
)(Datepicker)
